import React, { Component, PropTypes } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import classnames from 'classnames';
import { Input, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import  VendVendors  from './vendVendors';
import  VendUsers  from './vendUsers';
import VendSystemContacts from './vendSystemContacts';
import  VendServers  from './vendServers';
import  VendIntegrations from './vendIntegrations';
import VendSystemAgreements from './vendSystemAgreements';
import moment from 'moment';
import { connect } from 'react-redux';

class VendSystems extends Component {
    static displayName = VendSystems.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            loading: false,
            sysList: [],
            tabActive: null,
            sysActive: this.props.syspk !== null ? this.props.syspk[0].pk : [],
            userOptions: [],
            userActive: "DEFAULT",
            thisSysData: [],
            servOptions: [],
            servActive: "DEFAULT",
        }
        this.getSysList();
    }

    async getSysList() {//Note: the setState in the Else statement never seems to actually update state. This forces the fetch to be outside the prior if statements in order to run properly. Fix?
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            vendorpk: ""
        }
        const response = await fetch('GetVendorSystems', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (this.props.syspk == null) {
            this.setState({
                sysList: data
            })
        }
        else if (this.isNumeric(this.props.syspk) === true) {
            this.setState({
                sysActive: this.props.syspk,
                sysList: data,
                loading: true
            })
            this.getUserList(this.props.syspk);
        }
        else {
            this.setState({
                sysList: this.props.syspk,
                loading: true
            })
            this.getUserList(this.props.syspk[0].vendpk);
        }
        if (this.props.renderSource !== null) {
            this.getServerOptions();
            
        }
    }

    isNumeric(n) {//This neat little function I definitely didn't steal from StackOverflow determines in client whether a string is a number. Very useful for determining whether
                    //a prop passed is a pk or an object
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    async getUserList(e) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetVendUsers', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //console.log("user list data: " + JSON.stringify(data));
        //console.log("filtering on: " + JSON.stringify(e));
        this.setState({
            userOptions: data.filter(f => {
                return f.vendsystempk === e
            })
        }, () => {/*console.log("filtered: " + this.state.userOptions)*/ })
    }

    async getServerOptions() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetVendServers', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            servOptions: data
        })
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {//Once again, we listen for when a component's props are updated. This time, we need to know how to handle an updated syspk prop based on if it's a 
                                                   //pk or an object
        if (prevProps.syspk != this.props.syspk && this.props.syspk !== null) {
            if (this.isNumeric(this.props.syspk) !== true) {
                this.setState({
                    sysList: this.props.syspk,
                    sysActive: this.props.syspk[0].pk
                })
                //this.getUserList(this.props.syspk[0].vendpk);
            }
            else {
                this.setState({
                    sysActive: this.props.syspk
                })
            }
            this.setState({
                servActive: "DEFAULT",
                userActive: "DEFAULT"
            })
        }
    }

    tabToggle(tab) {
        if (this.state.tabActive !== tab) {
            this.setState({
                tabActive: tab
            });
        }
    }

    sysSelect(e) {
        this.setState({
            sysActive: e,
            servActive: "DEFAULT",
            userActive: "DEFAULT",
            loading: true
        })
        this.getUserList(e);
        this.getServerOptions(e);
    }

    showDataView() {
        let sysRef = []
            sysRef = this.state.sysList.filter(filter => {
                return filter.pk === this.state.sysActive
            })
        return (<div>
            <div style={{ color: sysRef[0].isactive ? '' : 'red' }}><h3>{sysRef[0].sysname}</h3><p />
                <b>{sysRef[0].syspurpose}</b><p />
                <ul>
                    <li>Hood Owner: {sysRef[0].hoodowner}</li>
                    <li>Tech Contact: {sysRef[0].techcontact}</li>
                </ul>
            </div>
                <p />
            <Nav tabs>
                {this.props.renderSource !== "vend" && <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '1' })} onClick={() => this.tabToggle('1')}>
                        Vendors
                    </NavLink>
                </NavItem>}
                {this.props.renderSource !== "user" && <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '2' })} onClick={() => this.tabToggle('2')}>
                        Users
                    </NavLink>
                </NavItem>}
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '3' })} onClick={() => this.tabToggle('3')}>
                        System Contacts
                    </NavLink>
                </NavItem>
                {this.props.renderSource !== "serv" && <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '4' })} onClick={() => this.tabToggle('4')}>
                        Servers
                    </NavLink>
                </NavItem>}
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '5' })} onClick={() => this.tabToggle('5')}>
                        Integrations
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={classnames({ active: this.state.tabActive === '6' })} onClick={() => this.tabToggle('6')}>
                        Agreements
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={this.state.tabActive}>
                {this.props.renderSource !== "vend" && <TabPane tabId='1'>
                    <div className="vendorChild"><VendVendors userData={this.state.returnable} vendpk={sysRef[0].vendpk} renderSource={"sys"} /></div>
                </TabPane>}
                {this.props.renderSource !== "user" && <TabPane tabId='2'>
                    <Input type="select" name="userselect" id="userselect" value={this.state.userActive} onChange={(e) => { this.setState({ userActive: e.target.value }) }}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.userOptions.map(item => (
                            <option value={item.pk}>{item.username}</option>
                        ))}
                    </Input>
                    {this.state.userActive !== "DEFAULT" && <div className="vendorChild"><VendUsers userData={this.state.returnable} userpk={this.state.userActive} renderSource={"sys"} userList={this.state.userOptions} key={this.state.userActive} /></div>}
                </TabPane>}
                <TabPane tabId='3'>
                    <div className="vendorChild"><VendSystemContacts syspk={sysRef[0].pk} userData={this.props.userData} /></div>
                </TabPane>
                {this.props.renderSource !== "serv" && <TabPane tabId='4'>
                    <Input type="select" name="servselect" id="servselect" value={this.state.servActive} onChange={(e) => { this.setState({ servActive: e.target.value }) }}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.servOptions.filter(filter => {
                            return filter.syspk === sysRef[0].pk
                        }).map(item => (
                            <option value={item.pk}>{item.servername}</option>
                        ))}
                    </Input>
                    {this.state.servActive != null && this.state.servActive !== "DEFAULT" && <div className="vendorChild"><VendServers userData={this.state.returnable} servpk={this.state.servOptions.filter(f => { return f.pk === this.state.servActive })} renderSource={"sys"} key={this.state.servActive} /></div>}
                </TabPane>}
                {this.props.renderSource !== "int" && <TabPane tabId='5'>
                    <div className="vendorChild"><VendIntegrations userData={this.state.returnable} intpk={sysRef[0].pk} renderSource="sys" /></div>
                </TabPane>}
                <TabPane tabId='6'>
                    <div className="vendorChild"><VendSystemAgreements userData={this.state.returnable} syspk={sysRef[0].pk} /></div>
                </TabPane>
            </TabContent>
        </div>);
    }

    render() {
        let displayView = <div></div>
        if (this.state.loading) { displayView = this.showDataView(); }
        return (<div>
            {this.props.syspk == null && <h2>Systems</h2>}<p />
            {this.props.syspk == null && <Input type="select" name="system" id="system" defaultValue="DEFAULT" onChange={(e) => this.sysSelect(e.target.value)}>
                <option value="DEFAULT" disabled>Select...</option>
                {this.state.sysList.map(item => (
                    <option value={item.pk}>{item.sysname}</option>
                ))}
            </Input>}
            <br />
            {displayView}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(VendSystems);